export const getSafeReturnPath = (path) => {
  const value = String(path || "").trim();

  if (!value.startsWith("/") || value.startsWith("//")) {
    return "/";
  }

  return value;
};

export const getReturnToFromSearch = (search = "") => {
  const params = new URLSearchParams(search);
  return getSafeReturnPath(params.get("returnTo"));
};

export const withReturnTo = (path, returnTo) => {
  const safeReturnTo = getSafeReturnPath(returnTo);

  if (safeReturnTo === "/") {
    return path;
  }

  return `${path}?returnTo=${encodeURIComponent(safeReturnTo)}`;
};
